// voiceEntryReducer.ts
import { voiceEntryActionTypes, voiceEntryState } from "./voiceEntryTypes";

export const INIT_STATE: voiceEntryState = {
  recordingStatus: false,
  remainingTime: 30,
  processingStatus: "idle",
  sqlResult: "",
  entryResult: {},
  missingFields: [],
  errorMessage: "",
  bookingApproved: false,
  loading: false,
  error: "",
};

const voiceEntryReducer = (state = INIT_STATE, action: any): voiceEntryState => {
  switch (action.type) {
    case voiceEntryActionTypes.API_RESPONSE_SUCCESS:
      if (!action.payload?.actionType) {
        console.error(
          `API_RESPONSE_SUCCESS: Missing actionType in payload. Action type: ${action.type}, Payload:`,
          action.payload
        );
        throw new Error(
          `Reducer error: Missing actionType in payload for API_RESPONSE_SUCCESS. Action: ${JSON.stringify(action)}`
        );
      }

      switch (action.payload.actionType) {
        case voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY:
          return {
            ...state,
            sqlResult: action.payload.data.sqlResult,
            entryResult: action.payload.data.entryResult,
            missingFields: action.payload.data.missingFields,
            processingStatus: "processed",
            errorMessage: "",
            loading: false,
          };

        case voiceEntryActionTypes.UPDATE_AUDIO_ENTRY:
          return {
            ...state,
            sqlResult: action.payload.data.sqlResult,
            entryResult: action.payload.data.entryResult,
            missingFields: action.payload.data.missingFields,
            processingStatus: "processed",
            errorMessage: "",
            loading: false,
          };

        case voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT:
          console.log("[Voice Entry Reducer API success] action.payload ", action.payload)
          return {
            ...state,
            missingFields: action.payload.data.missingFields,
            bookingApproved: true
            // roomOptions: action.payload.data.roomOptions,
            // isRoomListLoading: false,
            // errorMessage: "",
          };
        // Cases to be inserted later
        default:
          return {
            ...state,
            loading: false,
          };
      }

    case voiceEntryActionTypes.API_RESPONSE_ERROR:
      if (!action.payload?.actionType) {
        console.error(
          `API_RESPONSE_ERROR: Missing actionType in payload. Action type: ${action.type}, Payload:`,
          action.payload
        );
        throw new Error(
          `Reducer error: Missing actionType in payload for API_RESPONSE_ERROR. Action: ${JSON.stringify(action)}`
        );
      }

      switch (action.payload.actionType) {
        case voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY:
          return {
            ...state,
            errorMessage: action.payload.error,
            sqlResult: "",
            entryResult: {},
            processingStatus: "processed",
            loading: false,
          };

        case voiceEntryActionTypes.UPDATE_AUDIO_ENTRY:
          return {
            ...state,
            errorMessage: action.payload.error,
            sqlResult: "",
            entryResult: {},
            processingStatus: "processed",
            loading: false,
          };

        case voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT:
          console.log("[roomBookingActionTypes.APPROVED_ENTRY_SUBMIT:] error case", action.payload);

          return {
            ...state,
            missingFields: action.payload.data.missingFields,
            bookingApproved: false
            // isRoomListLoading: false,
            // errorMessage: action.payload.error,
            // roomOptions: [],
          };
        // Cases to be inserted later
        default:
          return {
            ...state,
            loading: false,
            error: action.payload?.error || "An unknown error occurred",
          };
      }
    case voiceEntryActionTypes.SET_RECORDING_STATUS:
      return {
        ...state,
        recordingStatus: action.payload,
        bookingApproved: false
      };
    case voiceEntryActionTypes.SET_REMAINING_TIME:
      return {
        ...state,
        remainingTime: action.payload,
        bookingApproved: false
      };
    case voiceEntryActionTypes.RESET_REMAINING_TIME:
      return {
        ...state,
        remainingTime: 30,
        bookingApproved: false
      };
    case voiceEntryActionTypes.SET_PROCESSING_STATUS:
      return {
        ...state,
        processingStatus: action.payload,
        bookingApproved: false
      };
    case voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY:
      return {
        ...state,
        loading: true,
        bookingApproved: false
      };

    case voiceEntryActionTypes.UPDATE_AUDIO_ENTRY:
      console.log("pre api SUBMIT_AUDIO_ENTRY_MANUAL_EDIT", action.payload);

      return {
        ...state,
        loading: true,
        bookingApproved: false
      };

    case voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT:
      console.log("[roomBookingReducer.ts] APPROVED_ENTRY_SUBMIT pre api called with data", action.payload);
      return {
        ...state,
        missingFields: [],
        bookingApproved: false,
        // isBookingDetailsLoading: true,
        errorMessage: "",
      };
    case voiceEntryActionTypes.CLEAR_ENTRY_RESULTS:
      return {
        ...state,
        sqlResult: "",
        bookingApproved: false,
        entryResult: {},
      };
    case voiceEntryActionTypes.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
        bookingApproved: false,
      };

    default:
      return { ...state };
  }
};

export default voiceEntryReducer;
